module.exports = __webpack_public_path__ + "img/cenz.0a790117.svg";